export const SOCIAL_PROFILE_URLS = {
  google: "https://maps.app.goo.gl/bS4cykpSzT3H7jYCA",
  facebook: "https://www.facebook.com/profile.php?id=61568879049463",
  instagram: "https://www.instagram.com/zencarbuying?igsh=MTBoOTA4czUxOXU2bg==",
  linkedin: "https://www.linkedin.com/company/zen-car-buying",
  yelp: "https://www.yelp.com/biz/zencarbuying",
}

export const SOCIAL_SCHEMA_SAME_AS = [
  SOCIAL_PROFILE_URLS.google,
  SOCIAL_PROFILE_URLS.facebook,
  SOCIAL_PROFILE_URLS.instagram,
  SOCIAL_PROFILE_URLS.linkedin,
  SOCIAL_PROFILE_URLS.yelp,
]

export const getSocialUrl = platform => SOCIAL_PROFILE_URLS[platform] || ""
